<template>
  <div class="pdfContainer">
    <div class="pdfLeft">
      <img class="pdfimg" src="../../assets/img/pdf_icon.png" alt="" />
      <p @click="clickbtn">{{ text }}</p>
    </div>
    <!--    <img class="arrowimg" src="../../assets/img/arrowLeft.svg" alt="" />-->
  </div>
</template>
<script>
export default {
  props: ['text'],
  methods: {
    clickbtn() {
      this.$emit('clickbtn');
    }
  }
};
</script>
<style lang="less" scoped>
.pdfContainer {
  display: flex;
  align-items: center;
  border-bottom: 2px solid #00a4b0;
  padding-bottom: 0.09rem;
  justify-content: space-between;
  .pdfLeft {
    display: flex;
    align-items: center;
    p {
      font-size: 0.16rem;
      /*color: #333333;*/
      margin: 0.02rem 0 0 0.1rem;
      line-height: 0.21rem;
      color: #00a4b0;
      font-weight: bold;
      cursor: pointer;
    }
  }
  .pdfimg {
    width: 0.16rem;
    height: 0.18rem;
    margin-left: 0.04rem;
  }
  .arrowimg {
    width: 0.07rem;
    height: 0.11rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Title/cPdfTitle.vue